// prospect-link widget — α.5 of the outreach-agent slice.
//
// A navigation chip the agent can drop inline to scope the chat to a
// specific prospect. H.2.4: the /outreach/prospects/:id route was retired;
// clicking this chip now writes the scope to sessionStorage and navigates
// to /outreach, where OutreachLayout reads + clears the stored scope on
// mount (same mechanism as the old Prospect page's "Chat about" button).
//
// Renders as a pill-shaped button (not <a>) because react-router-dom's
// declarative navigate() preserves SPA semantics — falling back to <a>
// would force a full page reload and lose the chat state.
//
// Tokens: bg-card / border-border / text-foreground — all real tailwind
// tokens declared in apps/web/src/styles/tailwind.css. No hex.

import { useNavigate } from 'react-router-dom';

interface Props {
  prospectId: string;
  label?: string;
}

export function ProspectLink({ prospectId, label }: Props) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      data-testid="prospect-link"
      data-prospect-id={prospectId}
      onClick={() => {
        // Write scope so OutreachLayout picks it up on mount and flips the
        // scope chip to this prospectId without a chat round-trip.
        sessionStorage.setItem('outreach-scope', JSON.stringify({ prospectId }));
        navigate('/outreach');
      }}
      className="inline-block rounded-full border border-border bg-card px-2 py-0.5 text-sm text-foreground hover:bg-background"
    >
      {label ?? prospectId}
    </button>
  );
}
